import classNames from 'classnames'
import React from 'react'

type GridHorizontalAlignment = 'center' | 'bottom'

type GridVerticalAlignment = 'right' | 'middle' | 'spread'

export interface GridProps {
  alignHorizontally?: GridHorizontalAlignment
  alignVertically?: GridVerticalAlignment
}

export const Grid: React.FC<GridProps> = ({
  alignHorizontally,
  alignVertically,
  children,
}) => {
  const classes: string[] = ['stk-gr']

  if (alignHorizontally) {
    classes.push(`stk-gr--${alignHorizontally}`)
  }

  if (alignVertically) {
    classes.push(`stk-gr--${alignVertically}`)
  }

  return <div className={classNames(...classes)}>{children}</div>
}

type ColumnSpan = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12

type ShrinkVariant =
  | 'shrink'
  | 'shrink-msm'
  | 'shrink-ts'
  | 'shrink-ss'
  | 'shrink-ls'
  | 'shrink-ws'

interface ColumnProps {
  msm?: ColumnSpan
  ts?: ColumnSpan
  ss?: ColumnSpan
  ls?: ColumnSpan
  ws?: ColumnSpan
  shrink?: ShrinkVariant
  size?: number
  className?: string
}

export const Column: React.FC<ColumnProps> = ({
  msm,
  ts,
  ss,
  ls,
  ws,
  shrink,
  size,
  className,
  children,
}) => {
  const settings = { msm, ts, ss, ls, ws } as any
  const columnClasses = []

  let columnSizeClasses = Object.keys(settings)
    .filter((key) => !!settings[key])
    .map((key) => `stk-gr__col-${settings[key]}-${key}`)

  if (columnSizeClasses.length) {
    columnClasses.push(...columnSizeClasses)
  } else if (size) {
    columnClasses.push(`stk-gr__col-${size}`)
  } else {
    columnClasses.push('stk-gr__col')
  }

  if (shrink) {
    columnClasses.push(`stk-gr__col--${shrink}`)
  }

  if (className) {
    columnClasses.push(...className.split(' '))
  }

  return <div className={classNames(columnClasses)}>{children}</div>
}
